import { ButtonsCustom } from 'enums/ButtonsCustomEnum';
import TipoRedirecionamento from 'enums/TipoRedirecionamento';
import { jsonProperty, Serializable } from 'ts-serializable';

export class InserirInteresse extends Serializable {
    @jsonProperty(String)
    email: string = '';

    @jsonProperty(String)
    chaveInteresse: string = '';

    @jsonProperty(Number)
    codigoSecaoInteresse: number = -1;
}

export class SecaoInteresse extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    titulo: string = '';

    @jsonProperty(String)
    corTitulo: string = '';

    @jsonProperty(String)
    tamanhoTitulo: string = '';

    @jsonProperty(Boolean)
    ocultarTitulo: Boolean = false;

    @jsonProperty(String)
    descricao: string = '';

    @jsonProperty(String)
    corDescricao: string = '';

    @jsonProperty(String)
    tamanhoDescricao: string = '';

    @jsonProperty(Boolean)
    ocultarDescricao: Boolean = false;

    @jsonProperty(String)
    textoApoio: string = '';

    @jsonProperty(String)
    corTextoApoio: string = '';

    @jsonProperty(String)
    tamanhoTextoApoio: string = '';

    @jsonProperty(Boolean)
    ocultarTextoApoio: Boolean = false;

    @jsonProperty(String)
    chaveInteresse: string = '';

    @jsonProperty(String)
    corSecao: string = '';

    @jsonProperty(String)
    estiloBotao: ButtonsCustom = ButtonsCustom.Button_01;

    @jsonProperty(String)
    usuarioResponsavel: string = '';
}

export default SecaoInteresse;
